import common from "../common";
import $ from "jquery";
import MiniSignal from 'mini-signals';
import GelButton from "../ui/GelButton";
import Button from "../ui/Button";
import SubmitButton from "../ui/SubmitButton";
import SecondaryButton from "../ui/SecondaryButton";

export default class Scene
{
    constructor(sceneId)
    {
        this.sceneId = sceneId;
        this.holder = null;
        this.content = null;

        this.panel = null;
        this.panelInner = null;
        this.panelFooter = null;

        this.signalListeners = [];
        this.buttons = {};

        this.restrictedHeightMode = false;

        this.signals = {
            next: new MiniSignal(),
            previous: new MiniSignal(),
            home: new MiniSignal(),
            setMusic: new MiniSignal()
        };
    }

    init()
    {
        console.log('scene init', this.sceneId);
        this.holder = $('<div id="' + this.sceneId + '" class="p3-scene"></div>');
        this.holder.hide();
        common.div.append(this.holder);

        setTimeout(() => {
            this.postInit();
        }, 1);

        if(common.basicMode)
        {
            $('#game').addClass('p3-preloaderBG');
        }
    }

    update(dt)
    {
        if(this.panelInner)
        {
            var realHeight = 0;

            this.panelInner.children().each(function(){
                realHeight += $(this).height() + Number($(this).css('marginBottom').replace("px", ""));
            });
            var diff = (Number(this.panelInner.css('minHeight').replace('px', '')) - realHeight) / 2;
            var marginAdjust = Number(this.panel.css('paddingTop').replace('px', '')) / 2;
            
            if(diff - marginAdjust > 0)
            {
                this.panelInner.children().first().css('marginTop', (diff - marginAdjust) + 'px');
            }
            else
            {
                this.panelInner.children().first().css('marginTop', '0px');
            }

            this.panelInner.css({
                'marginLeft': ((this.panel.width() - this.panelInner.width()) / 2) + 'px',
                'minHeight': this.panel.height() - this.panelFooter.height()
            });
            


            /*
            if(this.panel.width() == Number(this.panel.css('maxWidth').replace('px', '')))
            {
                this.panel.css('left', (this.holder.width() - this.panel.width()) / 2)
            }
            else
            {
                this.panel.css()
            }*/
        }
    }

    postInit()
    {
        this.holder.show();

        $(window).resize(this.resize.bind(this));
        this.resize();
    }

    addPanel()
    {
        var panel = $('<div class="p3-panel"></div>');
        var panelForm = $('<form></form>');
        panel.append(panelForm);
        var panelInner = $('<div class="p3-panelInner"></div>');
        panelForm.append(panelInner);
        var panelFooter = $('<div class="p3-panelFooter"></div>');
        panelForm.append(panelFooter);

        this.panel = panel;
        this.panelForm = panelForm;
        this.panelInner = panelInner;
        this.panelFooter = panelFooter;

        this.holder.append(panel);
        this.animatePanelIn();
        return panelInner;
    }

    addTopLogo()
    {
        //var logo = $('<div class="p3-panelItem"><img src="' + common.baseUrl + '/assets/images/ui_logo_world_united.png" style="height:7vh" /></div>');
        var logo = $('<div class="p3-panelItem"><img src="' + common.baseUrl + '/assets/images/ui_logo_1goal_0emissions.png" style="height:11vh" /></div>');
        this.panelInner.append(logo);
        return logo;
    }

    animatePanelIn()
    {
        if(common.basicMode)
            return;

        var p = {p:0};
        var startTop = 100;
        var endTop = 0;
        TweenMax.to(p, 0.5, {p:1, ease:Expo.easeOut, onUpdate:() => {
            this.holder.css('top', startTop - ((startTop-endTop) * p.p) + '%')
            this.holder.css('opacity', p.p);
        }});
    }

    animatePanelOut(callback)
    {
        if(common.basicMode)
        {
            callback();
            return;
        }
        /*
        for(var i in this.signalListeners)
        {
            this.signalListeners[i].detach();
        }
        this.signalListeners = [];*/

        var p = {p:1};
        TweenMax.to(p, 0.2, {p:0, ease:Sine.easeOut, onUpdate:() => {
            this.holder.css('opacity', p.p);
        }, onComplete: callback});
    }

    addSubmitButton(label, submit)
    {
        var button = new SubmitButton(label, null, submit);
        return button;
    }

    addSecondaryButton(label)
    {
        var button = new SecondaryButton(label, null);
        return button;
    }

    delayNextSignal()
    {
        setTimeout(()=>{
            this.signals.next.dispatch();
        }, 500);
    }

    destroy()
    {
        for(var i in this.signalListeners)
        {
            this.signalListeners[i].detach();
        }
        for(var i in this.buttons)
        {
            this.buttons[i].destroy();
        }
        this.holder.remove();

        $(window).unbind('resize', this.resize.bind(this));
    }

    resize()
    {

        /*
        if($(window).width() < $(window).height())
        {
            common.rotateScreen.show()
        }
        else
        {
            common.rotateScreen.hide();
            var fontSize = common.div.width() / 120;
            $('html').css('fontSize', fontSize + 'px');
        }*/
    }

    addContentHolder(addPadding)
    {
        this.content = $('<div class="p3-sceneContent"></div>');
        this.holder.append(this.content);

        if(addPadding)
        {
            this.content.addClass('p3-sceneContent-padded');
        }
    }
}